// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** change user password POST /api/admin/password */
export async function adminControllerChangeUserPassword(
	body: API.ChangePasswordRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/admin/password', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/admin/user */
export async function adminControllerGetList(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.AdminControllerGetListParams,
	options?: { [key: string]: any }
) {
	return request<API.PaginatedDto & { results?: API.UserListResponse[] }>(
		'/api/admin/user',
		{
			method: 'GET',
			params: {
				// page has a default value: 1
				page: '1',
				// size has a default value: 10
				size: '10',
				...params,
			},
			...(options || {}),
		}
	);
}

/** create user POST /api/admin/user */
export async function adminControllerRegister(
	body: API.UserRegisterRequest,
	options?: { [key: string]: any }
) {
	return request<string>('/api/admin/user', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** delete user DELETE /api/admin/user/${param0} */
export async function adminControllerDeleteUser(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.AdminControllerDeleteUserParams,
	options?: { [key: string]: any }
) {
	const { userId: param0, ...queryParams } = params;
	return request<string>(`/api/admin/user/${param0}`, {
		method: 'DELETE',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** update user PATCH /api/admin/user/${param0} */
export async function adminControllerUpdateUser(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.AdminControllerUpdateUserParams,
	body: API.UserUpdateRequest,
	options?: { [key: string]: any }
) {
	const { userId: param0, ...queryParams } = params;
	return request<string>(`/api/admin/user/${param0}`, {
		method: 'PATCH',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}

/** assign centers to user POST /api/admin/user/${param0}/center */
export async function adminControllerAssignCentersToUser(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.AdminControllerAssignCentersToUserParams,
	body: API.UserAssignCenterRequest,
	options?: { [key: string]: any }
) {
	const { userId: param0, ...queryParams } = params;
	return request<string>(`/api/admin/user/${param0}/center`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}

/** migrate POST /api/admin/user/migrate */
export async function adminControllerMigrate(
	body: API.UserMigrateDataRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/admin/user/migrate', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}
